var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import Button from "backpack-ui/dist/components/button";
import * as cn from "classnames";
import * as React from "react";
import * as styles from "./styles.css";
export var ButtonOutline = function (_a) {
    var children = _a.children, className = _a.className, onClick = _a.onClick, rest = __rest(_a, ["children", "className", "onClick"]);
    return (React.createElement(Button, __assign({ className: cn(styles.buttonOutline, className), onClick: onClick, color: "gray", size: "small", border: true, rounded: true }, rest), children));
};



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/components/button/buttonOutline.tsx
// module id = jY5B
// module chunks = 2